export default (theme) => ({
  airshipEmbed: {
    position: "relative",
    marginBottom: 32,
    "& iframe": {
      border: "none !important",
    },
  },
});
